import React from 'react';
import { Mail, Linkedin, Github, Twitter, MapPin } from 'lucide-react';
import { profileData } from '../mock/data';

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF8] pt-32 pb-24 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto">
        <div className="space-y-12">
          <div className="space-y-6">
            <h1 className="font-serif text-4xl lg:text-5xl text-[#1A1A1A] tracking-tight">
              Get in Touch
            </h1>
            <div className="h-px bg-[#E5E5E5] w-16"></div>
            <p className="text-lg text-[#6B6B6B] leading-relaxed max-w-2xl">
              Open to discussing applied AI projects, research collaborations, or engineering opportunities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-8">
            {/* Email */}
            <a
              href={`mailto:${profileData.email}`}
              className="group p-8 border border-[#E5E5E5] rounded-sm hover:border-teal-600 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <Mail className="text-teal-600 mt-1" size={24} />
                <div className="space-y-2">
                  <p className="text-sm text-[#999999] uppercase tracking-wider">
                    Email
                  </p>
                  <p className="text-base text-[#1A1A1A] group-hover:text-teal-600 transition-colors duration-300">
                    {profileData.email}
                  </p>
                </div>
              </div>
            </a>

            {/* Location */}
            <div className="p-8 border border-[#E5E5E5] rounded-sm">
              <div className="flex items-start gap-4">
                <MapPin className="text-teal-600 mt-1" size={24} />
                <div className="space-y-2">
                  <p className="text-sm text-[#999999] uppercase tracking-wider">
                    Location
                  </p>
                  <p className="text-base text-[#1A1A1A]">
                    {profileData.location}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-[#E5E5E5]">
            <p className="text-sm text-[#999999] uppercase tracking-wider mb-6">
              Connect
            </p>
            <div className="flex gap-6">
              <a
                href="https://www.linkedin.com/in/uddeshya-barnwal-b02510100/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#6B6B6B] hover:text-teal-600 transition-colors duration-300"
              >
                <Linkedin size={20} />
                <span className="text-sm">LinkedIn</span>
              </a>
              <a
                href="https://github.com/buddeshya"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#6B6B6B] hover:text-teal-600 transition-colors duration-300"
              >
                <Github size={20} />
                <span className="text-sm">GitHub</span>
              </a>
              <a
                href="https://x.com/BarnwalUddeshya"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[#6B6B6B] hover:text-teal-600 transition-colors duration-300"
              >
                <Twitter size={20} />
                <span className="text-sm">Twitter</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
